import { render, staticRenderFns } from "./EditOrderModal.vue?vue&type=template&id=7f1b74b4&"
import script from "./EditOrderModal.vue?vue&type=script&lang=js&"
export * from "./EditOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports